import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

export default function UList({ children, theme }) {
  return <ul className={`${styles.list} ${styles[theme]}`}>{children}</ul>;
}

UList.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.oneOf(['purple', 'blue'])
};
